import {
    CheckCircle,
    Gamepad
} from "@mui/icons-material";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Grid,
    Typography
} from "@mui/material";
import { motion } from "framer-motion";
import theme from "../../theme";
import { Me } from "./lichess/LichessAuth";




interface ConnectionStatusProps {
    me: Me;
}

export default function ConnectionStatus({ me }: ConnectionStatusProps) {
    return (
        <Card>
            <CardHeader
                title={
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="h5" fontWeight="bold" color="text.primary">
                            Connection Status
                        </Typography>
                        <CheckCircle sx={{ color: theme.palette.success.main }} />
                    </Box>
                }
            />
            <CardContent>
                <Grid container spacing={4} alignItems="center">
                    <Grid size={{ xs: 12, md: 8 }}>
                        <Typography
                            variant="h4"
                            fontWeight="bold"
                            color={theme.palette.success.main}
                            gutterBottom
                        >
                            Connected to Lichess
                        </Typography>
                        <Typography color="text.secondary">
                            Your device is successfully connected to the chess platform
                        </Typography>

                        <Box mt={2} display="flex" gap={2} flexWrap="wrap">
                            <Typography>
                                Username: {me.username}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <motion.div
                            animate={{
                                scale: 1,
                                rotate: 0,
                            }}
                            transition={{
                                scale: { duration: 1, repeat: 0 },
                                rotate: { duration: 2, repeat: 0, ease: "linear" },
                            }}
                            style={{
                                width: 80,
                                height: 80,
                                borderRadius: "50%",
                                borderWidth: 4,
                                borderStyle: "solid",
                                borderColor: theme.palette.success.main,
                                backgroundColor: theme.palette.success.light,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <Gamepad sx={{ fontSize: 40, color: "theme.palette.success.main" }} />
                        </motion.div>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}